import { useEffect, useState } from 'react';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  inputFields,
} from '../../shared/enums/activitys_enum';
import {
  useAllActivitysByEmployee,
  useGetDropdownOptions,
  useUpdateActivity,
} from '../../shared/hooks/UseActivity';

import {
  useAllComments,
  useCreateComment,
} from '../../shared/hooks/UseComment';

import { Form, Formik } from 'formik';
import moment from 'moment';
import * as qs from 'qs';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import * as Yup from 'yup';
import ExportComponent from '../../components/common/ExportComponent';
import SingleView from '../../components/common/SingleView';
import { TextArea } from '../../components/Form/Form';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import ActivityTableView from './_components/Activity-Table-View';

const AllActivityComponent = ({ employee }) => {
  const [data, setPageNumber, deleteBtnClicked, reloadData, setReloadData] =
    useAllActivitysByEmployee(employee._id);
  const [updateData] = useUpdateActivity();

  const { activitys_loading, activitys, total_activitys, page, pages } = data;

  const [comment_data, setActivity, setReloadComments] = useAllComments();
  const { comments, comments_loading } = comment_data;
  const [commentData, addData] = useCreateComment();
  const submitFormClicked = async (values) => {
    await addData(values);
    setReloadComments(true);
  };

  const [dropdownOptions] = useGetDropdownOptions();

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editField, setEditField] = useState(null);

  const [newValues, setNewValues] = useState(null);
  const [loadingActivityStatus, setLoadingActivityStatus] = useState(false);

  const updateStatus = async (id, status) => {
    // console.log("ID", id, value);
    if (id && status) {
      setLoadingActivityStatus(true);
      const newForm = new FormData();
      newForm.append('values', JSON.stringify(status));
      await updateData(id, newForm);
      await setReloadData(true);
      setEditId(null);
      setLoadingActivityStatus(false);
    } else {
      setEditId(null);
    }
  };

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (activitys) {
      convertToReadable(activitys, inputFields);
    }
  }, [activitys]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Activities', 'activities');
  };

  const userData = useSelector((state) => state.auth);
  var currentDate = moment().format('DD-MM-YYYY hh:mm A');

  const [total_estimated_time, setTotal_estimated_time] = useState(0);
  const [total_actual_time, setTotal_actual_time] = useState(0);

  useEffect(() => {
    if (activitys) {
      let total_activity_time = 0;
      let total_actual_time = 0;
      activitys.map((item) => {
        if (item.estimated_time) {
          total_activity_time =
            total_activity_time +
            Number(item.estimated_time ? item.estimated_time : 0);
          total_actual_time =
            total_actual_time + Number(item.actual_time ? item.actual_time : 0);
        }
      });
      setTotal_estimated_time(total_activity_time);
      setTotal_actual_time(total_actual_time);
    }
  }, [activitys]);

  const time_convert = (num) => {
    var hours = Math.floor(num / 60);
    var minutes = num % 60;
    return hours + 'Hours :' + minutes + ' Mins';
  };

  const history = useHistory();
  const location = useLocation();

  const handleSidebarChange = ({ name, value, type = 'search', condition }) => {
    const queryParams = qs.parse(window.location.search.replace('?', ''));
    if (type == 'conditional') {
      if (queryParams[type]) {
        if (queryParams[type][name]) {
          if (value && value.length > 0) {
            queryParams[type][name][condition ? condition : '$gte'] = value;
          } else {
            delete queryParams[type][name][condition ? condition : '$gte'];
          }
        } else {
          queryParams[type][name] = {};
          if (value && value.length > 0) {
            queryParams[type][name][condition ? condition : '$gte'] = value;
          } else {
            delete queryParams[type][name][condition ? condition : '$gte'];
          }
        }
      } else {
        queryParams[type] = {};
        queryParams[type][name] = {};
        if (value && value.length > 0) {
          queryParams[type][name][condition ? condition : '$gte'] = value;
        } else {
          delete queryParams[type][name][condition ? condition : '$gte'];
        }
      }
    } else {
      if (queryParams[type]) {
        if (value && value.length > 0) {
          queryParams[type][name] = value;
        } else {
          delete queryParams[type][name];
        }
      } else {
        queryParams[type] = {};
        if (value && value.length > 0) {
          queryParams[type][name] = value;
        } else {
          delete queryParams[type][name];
        }
      }
    }

    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true, // prettify url
    });

    history.push(`${location.pathname}?${query}`);
  };

  return (
    <div className='pace-done'>
      <div>
        <ExportComponent handleOnExport={handleOnExport} />

        <ActivityTableView employee={employee} />
      </div>
      <ReactModal
        isOpen={modal}
        contentLabel='Modal'
        className='Modal'
        overlayClassName='Overlay'
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className='btn btn-primary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          {modalData && (
            <>
              <div className='qv-body'>
                <SingleView
                  hideGallery={true}
                  data={modalData}
                  inputFields={inputFields}
                  label={PAGE_SINGLE_TITLE}
                  link={LINK_URL}
                  id={modalData._id}
                  hideAllBtn={true}
                  col={12}
                />
                <div className='card'>
                  <div className='card-body'>
                    <Formik
                      initialValues={{
                        comment: '',
                      }}
                      validationSchema={Yup.object({
                        comment: Yup.string().required('Required'),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        setSubmitting(true);
                        values.activity = modalData._id;
                        await submitFormClicked(values);
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {(formik) => {
                        console.log(formik);
                        return (
                          <Form>
                            <div className='row align-items-center'>
                              <div className='col-md-9'>
                                <TextArea
                                  label='Comment'
                                  name='comment'
                                  type='text'
                                />
                              </div>
                              <div className='col-md-3'>
                                <button
                                  type='submit'
                                  className='btn btn-success'
                                >
                                  {' '}
                                  {formik.isSubmitting
                                    ? 'SAVING...'
                                    : 'SAVE'}{' '}
                                </button>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <table className='table table-stripped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Comment</th>
                          <th>Comment By</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!comments_loading ? (
                          <>
                            {comments &&
                              comments.map((item, index) => {
                                return (
                                  <tr>
                                    <td> {index + 1} </td>
                                    <td> {item.comment} </td>
                                    <td>
                                      {' '}
                                      {item.created_by &&
                                        item.created_by.name}{' '}
                                    </td>
                                    <td>
                                      {' '}
                                      {item.createdAt &&
                                        moment(item.createdAt).format(
                                          'DD-MM-YYYY hh:mm A'
                                        )}{' '}
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <>
                            <p> Loading... </p>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AllActivityComponent;
